/* tslint:disable */
/* eslint-disable */
/**
 * Communication API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CommonErrorInternalServerErrorError {
    'code': CommonErrorInternalServerErrorErrorCodeEnum;
    'message': string;
}

export enum CommonErrorInternalServerErrorErrorCodeEnum {
    InternalServerError = 'INTERNAL_SERVER_ERROR',
    ApiConfigurationError = 'API_CONFIGURATION_ERROR',
    AuthorizerConfigurationError = 'AUTHORIZER_CONFIGURATION_ERROR',
    AuthorizerFailure = 'AUTHORIZER_FAILURE'
}


